import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";
import api from "../../lib/api";

export function useHeldTools(craftsmanId) {
    const [tools, setTools] = useState([]);
    useEffect(() => {
        if (!craftsmanId) { setTools([]); return; }
        api.get("/tools/held-by", { params: { craftsman_id: craftsmanId } }).then((r) => setTools(r.data.tools || [])).catch(() => setTools([]));
    }, [craftsmanId]);
    return tools;
}

export function HeldToolsWarning({ craftsmanId, name }) {
    const tools = useHeldTools(craftsmanId);
    if (!tools.length) return null;
    return (
        <div className="border border-red-300 bg-red-50 p-3 text-sm text-red-900 flex gap-2" data-testid="held-tools-warning">
            <Wrench className="w-4 h-4 mt-0.5 shrink-0" />
            <div>
                <b>{name || "Řemeslník"} má u sebe nářadí:</b> {tools.map((t, i) => <span key={t.id}>{i ? ", " : ""}<Link to={`/naradi/${t.id}`} className="underline">{t.name}{t.serial_number ? ` (${t.serial_number})` : ""}</Link></span>)}
                <div className="text-xs mt-1">Upozornění zůstane, dokud nářadí nevrátí (Nářadí → Kdo co má → Vrátit).</div>
            </div>
        </div>
    );
}
